exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".touch-action-manipulation[data-v-697dc245]{touch-action:manipulation}.fade[data-v-697dc245]{animation-name:oz-overlay-fade-697dc245;animation-duration:0.2s;will-change:opacity}@keyframes oz-overlay-fade-697dc245{0%{opacity:0}100%{opacity:1}}\n", ""]);

